/* K1 FFL cart gate (2026-10-15). See snippets/k1-ffl-cart-form.liquid.
   - Cart page: FFL form; checkout stays disabled until a choice is made and its fields are valid.
   - Cart drawer: checkout hidden; any checkout submit from the drawer goes to /cart instead.
   - Answers saved as cart attributes (/cart/update.js) + hidden attributes[] inputs on #cart-form.
   Undo: python3 /workspace/store-cleanup/ffl-cart-form-2026-10-15/undo.py */
(function () {
  if (window.__k1Ffl) return; window.__k1Ffl = true;
  var KILO = {
    'FFL Choice': 'Ship to KILO 1 SIX ARMS for pickup',
    'FFL Dealer Name': 'KILO 1 SIX ARMS',
    'FFL Number': '1-63-10943',
    'FFL Phone': '(800) 556-4563',
    'FFL Email': 'Support@Kilo1SixArms.com',
    'FFL Address': '526 McNatt Rd, Spruce Pine, AL 35585-4014'
  };
  var OTHER = 'Ship to another FFL dealer';
  var KEYS = ['FFL Choice', 'FFL Dealer Name', 'FFL Number', 'FFL Phone', 'FFL Email', 'FFL Address'];
  var DRAFT = 'k1-ffl-draft-v1';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var lastSaved = null, saveT = null, staleCleared = false;

  var RX = {
    name: function (v) { return v.trim().length >= 2; },
    num: function (v) { return /^\d-?\d{2}-?(?:[0-9a-z]{3}-?[0-9a-z]{2}-?[0-9a-z]{2}-?)?[0-9a-z]{5}$/i.test(v.replace(/\s+/g, '')); },
    phone: function (v) { var d = v.replace(/\D/g, ''); if (d.length === 11 && d.charAt(0) === '1') d = d.slice(1); return d.length === 10; },
    email: function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v.trim()); },
    street: function (v) { return v.trim().length >= 3; },
    city: function (v) { return v.trim().length >= 2; },
    state: function (v) { return /^[A-Z]{2}$/.test(v); },
    zip: function (v) { return /^\d{5}(-?\d{4})?$/.test(v.trim()); }
  };

  function form() { return document.querySelector('[data-k1-ffl]'); }
  function drawerNotice() { return document.querySelector('[data-k1-ffl-drawer]'); }
  function choice(f) { var r = f.querySelector('input[name="k1-ffl-choice"]:checked'); return r ? r.value : ''; }
  function field(f, k) { return f.querySelector('[data-ffl-field="' + k + '"]'); }
  function vals(f) { var o = {}; Object.keys(RX).forEach(function (k) { var el = field(f, k); o[k] = el ? el.value : ''; }); return o; }
  function fmtZip(z) { z = z.trim(); return /^\d{9}$/.test(z) ? z.slice(0, 5) + '-' + z.slice(5) : z; }

  function evaluate(f, showAll) {
    var c = choice(f), v = vals(f), bad = [];
    var dealer = f.querySelector('[data-k1-ffl-dealer]');
    if (dealer) dealer.hidden = c !== 'other';
    if (c === 'other') {
      Object.keys(RX).forEach(function (k) {
        var ok = RX[k](v[k] || ''), el = field(f, k), wrap = el && el.closest('.k1-ffl__f');
        if (!ok) bad.push(k);
        if (wrap) {
          var touched = showAll || el.dataset.touched === '1';
          wrap.classList.toggle('is-invalid', !ok && touched);
          el.setAttribute('aria-invalid', !ok && touched ? 'true' : 'false');
        }
      });
    }
    var valid = c === 'kilo' || (c === 'other' && bad.length === 0);
    var attrs = {};
    if (c === 'kilo') attrs = Object.assign({}, KILO);
    else if (c === 'other' && valid) attrs = {
      'FFL Choice': OTHER, 'FFL Dealer Name': v.name.trim(), 'FFL Number': v.num.replace(/\s+/g, '').toUpperCase(),
      'FFL Phone': v.phone.trim(), 'FFL Email': v.email.trim(),
      'FFL Address': v.street.trim() + ', ' + v.city.trim() + ', ' + v.state + ' ' + fmtZip(v.zip)
    };
    else KEYS.forEach(function (k) { attrs[k] = ''; });
    return { valid: valid, choice: c, bad: bad, attrs: attrs };
  }

  function checkoutButtons() { return document.querySelectorAll('button[name="checkout"], input[name="checkout"], .cart__checkout-button'); }

  function lock(btn, on) {
    if (on) {
      if (!btn.disabled) btn.disabled = true;
      if (btn.getAttribute('aria-disabled') !== 'true') btn.setAttribute('aria-disabled', 'true');
      if (!btn.classList.contains('k1-ffl-locked')) btn.classList.add('k1-ffl-locked');
      if (btn.dataset.k1FflLocked !== '1') btn.dataset.k1FflLocked = '1';
    } else if (btn.dataset.k1FflLocked === '1') {
      btn.disabled = false; btn.removeAttribute('aria-disabled'); btn.classList.remove('k1-ffl-locked'); delete btn.dataset.k1FflLocked;
    }
  }

  function save(attrs) {
    var key = JSON.stringify(attrs);
    if (key === lastSaved) return;
    clearTimeout(saveT);
    saveT = setTimeout(function () {
      lastSaved = key;
      fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: attrs }) })
        .catch(function () { lastSaved = null; });
    }, 350);
  }

  function apply(showAll) {
    var f = form(), d = drawerNotice();
    var btns = checkoutButtons();
    if (f) {
      var st = evaluate(f, showAll);
      f.querySelectorAll('[data-ffl-attr]').forEach(function (h) { h.value = st.attrs[h.getAttribute('data-ffl-attr')] || ''; });
      var msg = f.querySelector('[data-k1-ffl-status]');
      if (msg) {
        msg.classList.toggle('is-ok', st.valid);
        msg.textContent = st.valid ? 'FFL details saved. You can continue to checkout.' : (st.choice === 'other' ? 'Complete all dealer fields to continue to checkout.' : 'Choose an FFL option to continue to checkout.');
      }
      btns.forEach(function (b) { if (b.closest('[data-k1-ffl-drawer], .cart-drawer__summary') && d) lock(b, true); else lock(b, !st.valid); });
      f.__k1st = st;
      return st;
    }
    btns.forEach(function (b) { lock(b, !!(d && b.closest('.cart-drawer__summary'))); });
    if (document.querySelector('[data-k1-ffl-stale]') && !staleCleared) {
      staleCleared = true; var blank = {}; KEYS.forEach(function (k) { blank[k] = ''; }); save(blank);
    }
    return null;
  }

  function writeDraft(f) {
    try { var v = vals(f); v.choice = choice(f); localStorage.setItem(DRAFT, JSON.stringify(v)); } catch (e) {}
  }

  function restore(f) {
    if (f.dataset.k1FflInit) return; f.dataset.k1FflInit = '1';
    var saved = {}; try { saved = JSON.parse((f.querySelector('[data-k1-ffl-saved]') || {}).textContent || '{}'); } catch (e) {}
    var draft = null; try { draft = JSON.parse(localStorage.getItem(DRAFT) || 'null'); } catch (e) {}
    var set = function (k, v) { var el = field(f, k); if (el && v != null && el.value === '') el.value = v; };
    var pick = function (val) { var r = f.querySelector('input[name="k1-ffl-choice"][value="' + val + '"]'); if (r) r.checked = true; };
    if (saved['FFL Choice'] === KILO['FFL Choice']) pick('kilo');
    else if (saved['FFL Choice'] === OTHER) {
      pick('other');
      set('name', saved['FFL Dealer Name']); set('num', saved['FFL Number']); set('phone', saved['FFL Phone']); set('email', saved['FFL Email']);
      var m = /^(.*), ([^,]+), ([A-Z]{2}) (\d{5}(?:-\d{4})?)$/.exec(saved['FFL Address'] || '');
      if (m) { set('street', m[1]); set('city', m[2]); set('state', m[3]); set('zip', m[4]); }
    } else if (draft) {
      if (draft.choice) pick(draft.choice);
      Object.keys(RX).forEach(function (k) { set(k, draft[k]); });
    }
    lastSaved = JSON.stringify(evaluate(f, false).attrs) === JSON.stringify(savedSubset(saved)) ? JSON.stringify(savedSubset(saved)) : null;
  }
  function savedSubset(s) { var o = {}; KEYS.forEach(function (k) { o[k] = s[k] || ''; }); return o; }

  function onInput(e) {
    var f = form(); if (!f || !f.contains(e.target)) return;
    if (e.type === 'focusout' && e.target.dataset && e.target.dataset.fflField) e.target.dataset.touched = '1';
    if (e.type === 'change' && e.target.tagName === 'SELECT') e.target.dataset.touched = '1';
    var st = apply(false); writeDraft(f);
    if (st) save(st.attrs);
  }
  document.addEventListener('input', onInput, true);
  document.addEventListener('change', onInput, true);
  document.addEventListener('focusout', onInput, true);

  function guard(e) {
    var t = e.target, isSubmit = e.type === 'submit';
    var btn = isSubmit ? (e.submitter || null) : (t.closest && t.closest('button[name="checkout"], input[name="checkout"], .cart__checkout-button'));
    if (!isSubmit && !btn) return;
    if (isSubmit) {
      var fm = t; if (!fm || fm.id !== 'cart-form') return;
      var goingToCheckout = btn ? btn.name === 'checkout' : false;
      if (!goingToCheckout) return;
    }
    var d = drawerNotice(), f = form();
    if (d && btn && btn.closest('.cart-drawer__summary') && !f) {
      e.preventDefault(); e.stopImmediatePropagation(); window.location.href = root + 'cart'; return;
    }
    if (f) {
      var st = apply(true);
      if (!st.valid) {
        e.preventDefault(); e.stopImmediatePropagation();
        var first = st.choice === 'other' ? field(f, st.bad[0]) : f.querySelector('input[name="k1-ffl-choice"]');
        f.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 300);
      }
    }
  }
  document.addEventListener('click', guard, true);
  document.addEventListener('submit', guard, true);

  var raf = 0;
  function sync() {
    raf = 0;
    var f = form(); if (f) restore(f);
    apply(false);
  }
  function schedule() { if (!raf) raf = requestAnimationFrame(sync); }
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
  window.addEventListener('pageshow', function () { staleCleared = false; schedule(); });
})();
